import { render } from "./aboutus.vue?vue&type=template&id=1bf4e8fc"
import script from "./aboutus.vue?vue&type=script&lang=js"
export * from "./aboutus.vue?vue&type=script&lang=js"

import "./aboutus.vue?vue&type=style&index=0&id=1bf4e8fc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__